<template>
  <i :class="getClass"></i>
</template>

<script>
// @todo give this component a more generic name.
export default {
  props: {
    name: {
      // ES-1568: le module IA n'a pas de glyphe `jbsmd` (aucun des 135 ne represente
      // l'IA), donc `products.icon` vaut null en base et le nom peut etre absent.
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false
    },
    // Classe de repli quand le produit n'a pas de glyphe `jbsmd` (ex. "nc-icon nc-atom").
    fallback: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    getClass() {
      const glyph = this.name ? `jbsmd-${this.name}` : this.fallback;
      return [glyph, this.size ? `display-${this.size}` : ""];
    }
  }
};
</script>
